import { useCallback } from 'react';
import type {
  InteractiveContentChoice,
  RatingResult,
} from '@core-api/presentation/types/response';
import {
  usePreviewResultsIterator,
  getRatingGridPreviewResultsIteration,
} from '@mentimeter/slides-preview-results';

interface Range {
  min: number;
  max: number;
}

interface UseRatingGridPreviewResultsProps {
  isEnabled: boolean;
  choices: InteractiveContentChoice[];
  range: Range;
}

const previewResultsInterval = () => 1000;

export const useRatingGridPreviewResults = ({
  isEnabled,
  choices,
  range,
}: UseRatingGridPreviewResultsProps): RatingResult[] => {
  const getNextResults = useCallback(
    (iteration: number, previous: RatingResult[] = []) => {
      return getRatingGridPreviewResultsIteration({
        iteration,
        previous,
        extras: { choices, range },
      });
    },
    [choices, range],
  );

  return (
    usePreviewResultsIterator(
      isEnabled,
      getNextResults,
      previewResultsInterval,
    ) ?? []
  );
};
